import React from 'react'
import { Translate } from "react-redux-i18n";
import Moment from 'react-moment';
import Image from '../Image';
import { Icon , Button } from "@blueprintjs/core";

const ChatUser=({user, myGuid, expense, locale, deleteExpense})=>{
    const isMe = (user.guid===myGuid);
    return(
        <div className={`chat-element ${isMe?'sent-by-me':''}`}>
           {!isMe && 
                <div className="image user-avatar size-32">
                    <Image
                        src={user.image_url}
                        alt={user.f_name}
                    />
                </div>
            }
            <div className="message">
                {!isMe && <div className="name">{user.f_name} {user.l_name}</div>}

                <div className="text">
                    <Translate value="expenses.spent"/> {expense.amount} {expense.currency} {expense.reason}
                </div>
                {isMe && 
                    <Button intent="primary" className="cta secondary-color small remove-message" onClick={_ => deleteExpense(expense)} >
                        <Icon icon="trash" iconSize="16" className="icon" />
                    </Button>
                }
                <div className="timestamp">
                    <Moment locale={locale} fromNow ago>{expense.created_at}</Moment>
                    <Translate value="expenses.ago" />
                </div>
            </div>
        </div>
    )
}

export default ChatUser;